module.exports = __webpack_public_path__ + "static/media/sf-test-21.61389b77.mp3";